import { render, staticRenderFns } from "./CanditeReservations.vue?vue&type=template&id=67b30a97&scoped=true&lang=pug"
import script from "./CanditeReservations.vue?vue&type=script&lang=js"
export * from "./CanditeReservations.vue?vue&type=script&lang=js"
import style0 from "./CanditeReservations.vue?vue&type=style&index=0&id=67b30a97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b30a97",
  null
  
)

export default component.exports